/**
 * Global toast policy keyed by async-thunk type prefix.
 * Example prefix: "documentSearch/search" for action "documentSearch/search/fulfilled".
 *
 * Defaults:
 * - No entry => no auto-toast.
 * - Add entry per endpoint to opt-in.
 */
export const toastPolicyByTypePrefix = {
  /**
   * checkinApi/checkinApiSlice.js
   * createAsyncThunk("checkinApi/checkinDocument", ...)
   */
  "checkinApi/checkinDocument": {
    showSuccess: true,
    showError: true,
    successTitle: "Check-in completed",
    successMessage: "Document checked in successfully.",
    errorTitle: "Check-in failed",
    errorMessage: "Unable to check in the document.",
    domain: "Check-in",
  },

  "checkinApi/checkinDocumentsBulk": {
    showSuccess: true,
    showError: true,
    successTitle: "Bulk check-In completed",
    successMessage: "Documents checked in successfully.",
    errorTitle: "Bulk check-In failed",
    errorMessage: "Unable to check in one or more documents.",
    domain: "Check-in",
  },

  /**
   * documents/checkinNewRevisionSlice.js
   * createAsyncThunk("checkinNewRevision/post", ...)
   */
  "checkinNewRevision/post": {
    showSuccess: true,
    showError: true,
    successTitle: "New revision created",
    successMessage: "Document revision checked in successfully.",
    errorTitle: "New revision failed",
    errorMessage: "Unable to check in the new revision.",
    domain: "Check-in New Revision",
  },

  /**
   * documents/checkinExistingFlowSlice.js
   * createAsyncThunk("documents/checkinExistingFlow/perform", ...)
   */
  "documents/checkinExistingFlow/perform": {
    showSuccess: true,
    showError: true,
    successTitle: "Check-in completed",
    successMessage: "Document checked in successfully.",
    errorTitle: "Check-in failed",
    errorMessage: "Unable to check in the document.",
    domain: "Check-in Existing",
  },

  /**
   * documents/deleteWorkingDocumentSlice.js
   * createAsyncThunk("documents/deleteWorkingDocument", ...)
   */
  "documents/deleteWorkingDocument": {
    showSuccess: true,
    showError: true,
    successTitle: "Document deleted",
    successMessage: "",
    errorTitle: "Delete failed",
    errorMessage: "Unable to delete the document.",
    domain: "Delete Working Document",
  },

  /**
   * documents/documentCheckoutFlowSlice.js
   * createAsyncThunk("documents/documentCheckoutFlow/performCheckout", ...)
   */
  "documents/documentCheckoutFlow/performCheckout": {
    showSuccess: true,
    showError: true,
    successTitle: "Checked-out completed",
    successMessage: "Operation completed successfully.",
    errorTitle: "Checked-out failed",
    errorMessage: "Unable to complete checkout operation.",
    domain: "Checkout",
  },
};

/**
 * Global defaults used when an endpoint has a policy entry.
 * Per-endpoint policy and per-request meta can override these fields.
 */
export const toastPolicyDefaults = {
  showSuccess: false,
  showError: true,
  successTitle: "Completed!",
  successMessage: "Your request was completed successfully.",
  errorTitle: "We Couldn't Complete Your Request",
  errorMessage: "Unable to complete the request. Please try again.",
};
